module.exports = __webpack_public_path__ + "static/media/VIP_tab_active@3x.98733bde.png";